import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {useActionBlockPreviewProps} from "~/cabinet/vue/client/events/action/types/useActionBlockPreview";
import {
    OnlineChatClientCallgateActionDescription
} from "~/cabinet/ts/data/events/ActionDescription";
import InputWithVariablesPreview from "~/cabinet/vue/interface/tinymce/InputWithVariablesPreview.vue";


const __default__ = {
    name: "OnlineChatCallgateBlockPreview"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
        ...useActionBlockPreviewProps<OnlineChatClientCallgateActionDescription>()
    },
  setup(__props) {

let props = __props;

return (_ctx: any,_cache: any) => {
  return (_unref(props).params.mobileText)
    ? (_openBlock(), _createBlock(InputWithVariablesPreview, {
        key: 0,
        text: _unref(props).params.mobileText,
        variables: _ctx.contentVariables
      }, null, 8, ["text", "variables"]))
    : _createCommentVNode("", true)
}
}

})